import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d20cf66e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animePushToShadow__front" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "animePushToShadow__back" }, null, -1))

import { withDefaults, computed } from 'vue'
import { useMediaQuery } from '@vueuse/core'

import { BREAK_POINTS } from '@/constants/mediaQuery'

interface Props {
  tag?: string
  backgroundColor?: string
  shadowColor?: string
  shadowX?: string
  shadowY?: string
  disabled?: boolean
  rounded?: string | 'pill' | 'circle'
  duration?: string
  easing?: string

  // interface extendsを使用するとエラーになるため、前述をベタ書き
  wide?: {
    tag?: string
    backgroundColor?: string
    shadowColor?: string
    shadowX?: string
    shadowY?: string
    disabled?: boolean
    rounded?: string | 'pill' | 'circle'
    duration?: string
    easing?: string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimationPushToShadow',
  props: {
    tag: { default: 'span' },
    backgroundColor: { default: '#fff' },
    shadowColor: { default: '#718998' },
    shadowX: { default: '4px' },
    shadowY: { default: '4px' },
    disabled: { type: Boolean, default: false },
    rounded: null,
    duration: { default: '0.2s' },
    easing: { default: 'cubic-bezier(0, 0, 0.58, 1)' },
    wide: null
  },
  setup(__props: any) {

const props = __props as { tag: string, backgroundColor: string, shadowColor: string, shadowX: string, shadowY: string, disabled: boolean, rounded?: string | 'pill' | 'circle', duration: string, easing: string, wide?: {
    tag?: string
    backgroundColor?: string
    shadowColor?: string
    shadowX?: string
    shadowY?: string
    disabled?: boolean
    rounded?: string | 'pill' | 'circle'
    duration?: string
    easing?: string
  } }

/**
 * AnimationPushToShadow.
 * @description コンポーネントを囲うボタンやリンク要素に`.animationLink`のCSSクラスを付与してください。
 */



const className = computed(() => {
  return ['animePushToShadow', props.disabled ? 'disabled' : '']
})

const isWideScreen = useMediaQuery(`(min-width: ${BREAK_POINTS.pc}px)`)

const style = computed(() => {
  const backgroundColor =
    (isWideScreen.value && props.wide?.backgroundColor) || props.backgroundColor
  const shadowColor =
    (isWideScreen.value && props.wide?.shadowColor) || props.shadowColor
  const shadowX = (isWideScreen.value && props.wide?.shadowX) || props.shadowX
  const shadowY = (isWideScreen.value && props.wide?.shadowY) || props.shadowY
  const rounded = (() => {
    const value = (isWideScreen.value && props.wide?.rounded) || props.rounded
    switch (value) {
      case 'pill':
        return '999px'
      case 'circle':
        return '50%'
      default:
        return value
    }
  })()
  const duration =
    (isWideScreen.value && props.wide?.duration) || props.duration
  const easing = (isWideScreen.value && props.wide?.easing) || props.easing

  return {
    '--animePushToShadow-background-color': backgroundColor,
    '--animePushToShadow-shadow-color': shadowColor,
    '--animePushToShadow-shadow-x': shadowX,
    '--animePushToShadow-shadow-y': shadowY,
    '--animePushToShadow-rounded': rounded,
    '--animePushToShadow-duration': duration,
    '--animePushToShadow-easing': easing,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    class: _normalizeClass(_unref(className)),
    style: _normalizeStyle(_unref(style))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _hoisted_2
    ]),
    _: 3
  }, 8, ["class", "style"]))
}
}

})